import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { UserAuth } from '../../context/AuthContext'
import axios from 'axios';
import validator from 'email-validator';

const Login = () => {

  const API_URL = process.env.REACT_APP_FIREBASE_API_URL_SERVER

  const { signIn } = UserAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const isValid = /^[a-zA-Z0-9]+$/.test(email);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const [loading, setLoading] = useState();
  const [showNotification, setShowNotification] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  /* Form Data */
  const formData = [
    { id: 'username', title: 'Username atau Email' },
    { id: 'password', title: 'Password' },
  ]

  /* Handle Form Input */
  const setHandleInput = (id, e) => {
    if (id === 'username') {
      setEmail(e.target.value.toLowerCase());
    } else if (id === 'password') {
      setPassword(e.target.value);
    }
  };

  const setTypeInput = (id) => {
    if (id === 'username') {
      return "text";
    } else if (id === 'password') {
      return "password";
    }
  }

  /* Render Form */
  const formElement = formData.map((hasil, i) =>
    <label className="block">
      <span className="text-gray-700">{hasil.title}</span>
      <input onChange={(e) => setHandleInput(hasil.id, e)} type={setTypeInput(hasil.id)} className="mt-0 block w-full pl-1 pr-1 px-1 border-0 border-b border-black focus:ring-0 focus:border-primary" autoComplete="off" />
      {hasil.id === "password" && <Link className="text-xs text-gray-600 hover:underline" to="/forgot">Lupa
        Password?</Link>}
    </label>
  );



  useEffect(() => {
    return () => {
      clearTimeout(timeoutId);
    };
  }, [timeoutId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowNotification(false);
    setLoading(true);
    try {
      if (!email) {
        throw new Error('Username atau email harus diisi');
      }
      if (!password) {
        throw new Error('Password harus diisi');
      }
      /* start */
      if (email.indexOf(" ") !== -1) {
        throw new Error('Akun kamu tidak ditemukan');
      }
      if (!validator.validate(email)) {
        if (!isValid) {
          throw new Error('Akun kamu tidak ditemukan');
        }
        if (!/[a-zA-Z]/.test(email)) {
          throw new Error('Akun kamu tidak ditemukan');
        }
      }
      if (email.length < 4) {
        throw new Error('Akun kamu tidak ditemukan');
      }
      if (email.length > 16) {
        throw new Error('Akun kamu tidak ditemukan');
      }
      if (password.length > 32) {
        throw new Error('Akun kamu tidak ditemukan');
      }
      if (password.length < 6) {
        throw new Error('Akun kamu tidak ditemukan');
      }
      /* end */
      if (/^[a-zA-Z0-9]+$/.test(email)) {
        const response = await axios.post(API_URL + 'api/processLogin', { username: email, password: password })
        if (response.data.response === true) {
          const login = await axios.post(API_URL + 'api/checkUsername', { username: email, getEmail: "yes" })
          await signIn(login.data.email, password);
          navigate('/');
        }
        if (response.data.response === false) {
          throw new Error('Akun kamu tidak ditemukan')
        }
      } else {
        await signIn(email, password);
        navigate('/');
      }
    } catch (e) {
      setShowNotification(true);
      switch (e.code) {
        case 'auth/invalid-email':
          setError('Akun kamu tidak ditemukan');
          break;
        case 'auth/wrong-password':
          setError('Akun kamu tidak ditemukan');
          break;
        case 'auth/user-disabled':
          setError('Akun kamu tidak dapat digunakan');
          break;
        case 'auth/user-not-found':
          setError('Akun kamu tidak ditemukan');
          break;
        case 'auth/operation-not-allowed':
          setError('Akun kamu sedang tidak dapat digunakan');
          break;
        default:
          setError(e.message);
          break;
      }
    } finally {
      setLoading(false);
      setTimeoutId(setTimeout(() => setShowNotification(false), 7000));
    }
  }

  return (
    <div className="antialiased bg-primary md:block md:bg-indigo-50" style={{ backgroundImage: `url('/images/bg-body.png')` }}>
      <div className="max-w-[600px] mx-auto max-h-screen min-h-screen bg-white shadow-2xl border-4 border-primary md:border-0 relative">
        {loading && (
          <div className="absolute top-0 left-0 right-0 bottom-0 bg-black opacity-60 flex items-center justify-center">
            <img src='/logo192.png' alt="Loading..." className="w-10 h-10" />
          </div>
        )}
        {showNotification && (
          <div className="px-4 fixed bottom-0 w-full max-w-[600px] transform mb-8 animate-fade-in animate-slide-up">
            <div className="bg-stone-900 text-white w-full rounded p-4 text-sm font-semibold flex justify-between">
              {error}
              <span className="text-primary cursor-pointer" onClick={() => setShowNotification(false)}>Ok</span>
            </div>
          </div>
        )}
        <div className="p-4 border-b">
          <h1 className="font-medium text-md">Masuk untuk mengakses IziUSE</h1>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-6 p-4">
            {formElement}
            <label className="block">
              <button className="w-full px-4 py-2 rounded-md font-semibold text-white bg-primary flex flex-row justify-center items-center hover:bg-secondary focus:outline-none focus:bg-secondary" type="submit">Masuk Sekarang</button>
            </label>
          </div>
        </form>
        <div className="pt-5">
          <p className="mb-5 text-sm font-medium text-center text-slate-500"> Belum punya akun? <Link className="font-medium text-secondary hover:underline" to="/signup">Daftar di sini</Link></p>
        </div>
      </div>
    </div>
  )
}

export default Login
